"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductSeo = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const utils_1 = require("@obvio/utils");
const next_seo_1 = require("next-seo");
function ProductSeo({ product, productDetails, }) {
    const contextPath = (0, app_1.useContextPath)('ecommerce.product');
    const { id, title, seoTitle, seoDescription, description, images } = product;
    const mappedImages = images.map((image) => {
        var _a;
        return ({
            url: `${(0, app_1.getHomeUrl)()}/_next/image?url=
    ${encodeURIComponent(`${contextPath}/${id}/${image.name}`)}&w=1200&q=75`,
            width: 1200,
            height: Math.round(1200 / Number((_a = image.ratio) !== null && _a !== void 0 ? _a : 1)),
            type: `image/${image.name.split('.')[1]}`,
            alt: image.name,
        });
    });
    const name = (0, utils_1.capitalize)(seoTitle !== null && seoTitle !== void 0 ? seoTitle : title);
    const desc = seoDescription !== null && seoDescription !== void 0 ? seoDescription : description;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(next_seo_1.NextSeo, { title: name, description: desc, openGraph: Object.assign({}, (mappedImages ? { images: mappedImages } : {})) }), (0, jsx_runtime_1.jsx)(next_seo_1.ProductJsonLd, Object.assign({ productName: name, description: desc, images: mappedImages.map((image) => image.url) }, productDetails))] }));
}
exports.ProductSeo = ProductSeo;
